import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild, HostListener, ElementRef } from '@angular/core';
import { SampleView } from 'src/app/shared/enums/sample-view.enum';
import { Sample, Analyses } from 'src/app/shared/models/sample.model';
import { CurrentOrderService } from 'src/app/shared/services/current-order.service';
import { Analysis } from 'projects/dop-ordering/src/lib/models/analysis.model';
import { AnalysisType, AnalysisToolTip, CiType } from 'projects/dop-ordering/src/public-api';
import { AnalysisDisplay } from 'src/app/shared/models/analysis-display.model';
import { OverlayPanel } from 'primeng/overlaypanel';
import AnalysesDetailService from './analyses-detail.service';
import { BaseComponent } from 'src/app/features/guided-order/base.component';
import { RemoveAnalysisService } from 'src/app/features/guided-order/samples/services/remove-analysis.service';
import { AnalysesToolTipService } from 'src/app/features/guided-order/samples/services/analyses-tool-tip.service';
import { TranslationService } from 'projects/dop-core/src/public-api';
import { StandardComment } from '../models/standard-comment.model';
import { AddAnalysisService } from 'src/app/features/guided-order/samples/add-analyses/add-analyses.service';
import { LinkedAnalysisSpecificationService } from 'src/app/features/guided-order/samples/services/linked-analysis-specification.service';
import { MonographToolTip } from '../models/monograph/monograph-tool-tip.model';
import { InvoiceableItemType } from '../models/specification/analyses-response.model';
import { FormatterHelperService } from '../services/formatter-helper.service';
import AnalysisHelper from 'projects/dop-ordering/src/lib/features/dop-analysis/dop-analysis.helper';
import { MessageService } from 'primeng/api';
import { PriorityItem, SharedMessageService } from 'src/app/shared/services/shared-message.service';
import { Tooltip } from 'primeng/tooltip';
import { ReportGrouping } from '../enums/report-grouping.enum';
import { UsePriority } from '../enums/use-priority.enum';

@Component({
  selector: 'app-analyses-detail',
  templateUrl: './analyses-detail.component.html',
  styleUrls: ['./analyses-detail.component.scss']
})
export class AnalysesDetailComponent extends BaseComponent implements OnInit, OnChanges {

  @ViewChild('overlayReference1') overlayReference: OverlayPanel;
  @Input() isReadOnly: boolean;
  @Input() sampleView: SampleView;
  @Input() sampleCode: string;
  @Input() analysisEdited: boolean;
  @Input() enableMixPriorityForCloneOrder: boolean;
  

  sampleDisplay = SampleView;

  @Output() public openSidebar = new EventEmitter<{ sidebar: string }>();
  @Output() public removeAnalyses = new EventEmitter();

  sample: Sample;
  displayPrice: boolean;
  analysesAdded: boolean;
  displayStructuredComment = false;
  structuredCommentValues: StandardComment[] = [];
  structuredCommentHeader: string;
  analysisList: Analysis[] = [];
  isSampleLevelMatrix = false;

  toolTipData: AnalysisToolTip;
  monographToolTipData: MonographToolTip;
  previousAnalysisToolTip: AnalysisDisplay;
  enableTooltip = true;
  overlayClass = 'analyses-detail-adjust';
  AnalysisHelper = AnalysisHelper;

  options: any[];
  selectedOption: string;
  showTooltip: boolean = false;
  timeoutId: any;
  showCustomToast : boolean = false;
  OrderLevelPriority: string;
  vbeiPriorityLevelWaring: string;
  priorities: PriorityItem[];
  tempSample : Sample;

  constructor(
    currentOrderService: CurrentOrderService,
    private removeAnalysesService: RemoveAnalysisService,
    private analysesToolTipService: AnalysesToolTipService,
    private addAnalysisService: AddAnalysisService,
    private linkedAnalysisSpecificationService: LinkedAnalysisSpecificationService,
    private formatterHelperService: FormatterHelperService,
    private messageService: MessageService,
    private SharedMessageService : SharedMessageService,
  ) {
    super(currentOrderService);
    this.isSampleLevelMatrix = this.currentOrderService.currentOrder?.orderTemplate?.isSampleLevelMatrix;
  }

  ngOnInit(): void {
    this.vbeiPriorityLevelWaring = TranslationService.translate('vbeiPriorityLevelWaring');
    this.displayPrice = this.currentOrder.displayPrice;
    if (this.currentOrder.orderTemplate.structuredComment && this.currentOrder.orderTemplate.structuredComment.toLowerCase() !== 'none') {
      this.displayStructuredComment = true;
      this.structuredCommentHeader = this.currentOrder.standardCommentTemplate?.templateName;
      const commentList: StandardComment[] = [];
      commentList.push({ code: 'null', value: 'None' });
      if (this.currentOrder.standardCommentTemplate?.standardComments
        && this.currentOrder.standardCommentTemplate.standardComments?.length > 0) {
        for (const n in this.currentOrder.standardCommentTemplate.standardComments) {
          if (this.currentOrder.standardCommentTemplate.standardComments[n] != null) {
            commentList.push({
              code: this.currentOrder.standardCommentTemplate.standardComments[n].code,
              value: this.currentOrder.standardCommentTemplate.standardComments[n].value
            });
          }
        }
      }
      this.structuredCommentValues = commentList;
    }
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.sampleCode) {
      this.getCurrentSample();
      this.setIsAnalysisAdded();
    }
    if (changes.analysisEdited) {
      this.getCurrentSample();
      this.setIsAnalysisAdded();
    }
  }  

  updateTooltip(value: string) {
    if (this.shouldShowTooltip(value)) {
      this.showTooltip = true;
      this.showWarning();
    } else {
      this.showTooltip = false;
    }
  }

  shouldShowTooltip(value: string): boolean {
    this.getCurrentSample();
    this.SharedMessageService.currentNames.subscribe((items: PriorityItem[]) => {
      this.priorities = items;
      const foundItem = items.find(item => item.code == this.sample.eurofinsSampleCode);
      if (foundItem) {
        this.OrderLevelPriority = foundItem.priority;
      }
      else{
        this.OrderLevelPriority='Standard';
      }
    });
    return value !== 'undefined' &&
      value !== 'None' &&
      (this.currentOrder.orderTemplate.enableReportGrouping ? this.currentOrder.samples[0].analyticalReportGroupingRule === ReportGrouping.SAMPLE : this.currentOrder.orderTemplate.usePriority === UsePriority.SAMPLE)
      &&  this.OrderLevelPriority !== value;
  }

  showWarning() {
    this.showCustomToast = true;
    setTimeout(() => {
      this.showCustomToast = false;
    }, 5000); // 

    this.messageService.add({severity: 'warn',
      detail: this.vbeiPriorityLevelWaring, life:5000 });
  }
  async onStructuredCommentChange(analysis) {
    const value = analysis.structuredComment?.value;
    if (value != null) { 
      this.updateTooltip(value);
    }    this.analysisList = [];
    if (analysis.analysisType === AnalysisType.FullSubgroup) {
      this.analysisList = analysis.childDisplay.map(x => {
        const item = new Analysis();
        item.subGroupKey = this.sample.analyses.filter(z => z.eurodatKey === x.eurodatKey)[0].subGroupKey;
        if (x.analysisType === AnalysisType.SubgroupWithTest) {
          item.testCode = x.code;
        } else {
          item.packageCode = x.code;
        }
        item.eurodatKey = x.eurodatKey;
        item.displayName = x.displayName;
        item.analysisType = x.analysisType;
        item.price = x.price;
        return item;
      });
    } else if (analysis.analysisType === AnalysisType.SalesCatalogueTest
      || analysis.analysisType === AnalysisType.SalesCatalogueTestBundle
      || analysis.analysisType === AnalysisType.MonographTest) {
      if (analysis.analysisType === AnalysisType.SalesCatalogueTestBundle) {
        analysis.testBundleCode = analysis.subgroupCode;
      }

      analysis.testCode = analysis.code;
      analysis.salesCatalogCode = analysis.salesCatalogueCode;
    } else if (analysis.analysisType === AnalysisType.SalesCataloguePackage
      || analysis.analysisType === AnalysisType.MonographPackage) {
      analysis.packageCode = analysis.code;
      analysis.salesCatalogCode = analysis.salesCatalogueCode;
    } else {
      if (analysis.analysisType === AnalysisType.CustomerPackage) {
        analysis.subGroupKey = analysis.eurodatKey;
      }
    }

    this.analysisList.push(analysis);
    const invoiceableItemRequest =
      this.addAnalysisService.prepareSampleInvoiceableItemRequest
        ([this.sample], this.analysisList, this.currentOrder.quotation.code, true);
    await this.addAnalysisService.updateAnalysisCommentToSample(
      this.sampleCode, analysis.structuredComment.value, invoiceableItemRequest);
    let currentSelectedAnalysis: Analysis[] = [];
    this.analysisList.forEach(x => {
      const currentPL = this.sample.planningLines.filter(y => ((
        y.quotationLineCode !== undefined && y.quotationLineCode === x.eurodatKey)
        || (y.groupCode !== undefined && y.groupCode === x.eurodatKey))
        || (y.testCode === x.testCode && y.invoiceableItemType === InvoiceableItemType.Test)
        || (y.packageCode === x.packageCode && y.invoiceableItemType === InvoiceableItemType.Package))[0];

      if (analysis.analysisType === AnalysisType.FullSubgroup) {
        currentSelectedAnalysis = this.sample.analyses.filter(y => y.subGroupKey === x.subGroupKey);
      } else if (analysis.analysisType === AnalysisType.SalesCataloguePackage
        || analysis.analysisType === AnalysisType.MonographPackage) {
        currentSelectedAnalysis = this.sample.analyses.filter(y => y.packageCode === x.packageCode
          && y.salesCatalogCode === x.salesCatalogCode);
      } else if (analysis.analysisType === AnalysisType.SalesCatalogueTest
        || analysis.analysisType === AnalysisType.MonographTest
        || analysis.analysisType === AnalysisType.SalesCatalogueTestBundle) {
        currentSelectedAnalysis = this.sample.analyses.filter(y => y.testCode === x.testCode
          && y.testBundleCode === x.testBundleCode
          && y.salesCatalogCode === x.salesCatalogCode);
      } else {
        currentSelectedAnalysis = this.sample.analyses.filter(y => y.eurodatKey === x.eurodatKey);
      }

      if (currentPL) {
        currentPL.structuredComment = analysis.structuredComment.value;
      }
      currentSelectedAnalysis?.forEach(z => z.structuredComment = analysis.structuredComment.value);
      currentSelectedAnalysis?.forEach(z => z.showSurgeIcon = this.showTooltip);
    }
    );

    this.linkedAnalysisSpecificationService.reMapAnalysisDisplay(this.sample);
  }
  getCurrentSample() {
    this.sample = this.currentOrder.samples.filter(x => x.sampleCode === this.sampleCode).shift();
  }

  setIsAnalysisAdded() {
    this.analysesAdded = this.sample.analyses && this.sample.analyses.length > 0;
    if (this.analysesAdded) {
      this.enableTooltip = false;
      setTimeout(() => {
        this.enableTooltip = true;
      }, 3000);
    }
  }

  getTotalPrice(): string {
    let total = 0;
    if (this.sample.analyses) {
      total += this.sample.analyses.reduce((acc, y) => acc + (y.price*y.executionNumber), 0);
      return this.getPriceDisplay(total);
    }
    return '';
  }

  showAddAnalysesPanel() {
    this.openSidebar.emit({ sidebar: 'analyses' });
  }

  getPriceDisplay(price: number): string {
    const currencyCode =  this.currentOrderService.currentOrder.quotation.currencyCode + ' ';
    return this.formatterHelperService.formatCurrency(price, currencyCode);
  }

  get mandatoryAnalyses() {
    return this.sample.analyses.filter(a => a.isMandatory);
  }

  displayToolTip(analysisDisplay: AnalysisDisplay): boolean {
    return analysisDisplay.analysisType === AnalysisType.FreeQLPackage
      || analysisDisplay.analysisType === AnalysisType.SubgroupWithPackage
      || analysisDisplay.analysisType === AnalysisType.CustomerPackage
      || analysisDisplay.analysisType === AnalysisType.SalesCataloguePackage
      || analysisDisplay.analysisType === AnalysisType.MonographTest
      || analysisDisplay.analysisType === AnalysisType.MonographPackage;
  }

  async removeAnalysis(analysesDisplay: AnalysisDisplay) {
    this.getCurrentSample();
    this.removeAnalyses.emit();
    const analyses = this.sample.analyses.filter(x =>
      (x.eurodatKey && x.eurodatKey === analysesDisplay.eurodatKey)
      || (x.salesCatalogCode === analysesDisplay.salesCatalogueCode
        && ((x.analysisType === AnalysisType.SalesCatalogueTest
          && x.testCode === analysesDisplay.code
          && (!x.testBundleCode || x.testBundleCode === analysesDisplay.subgroupCode))
          || (x.analysisType === AnalysisType.SalesCataloguePackage
            && x.packageCode === analysesDisplay.code)))
      || (x.salesCatalogCode === analysesDisplay.salesCatalogueCode
        && ((x.analysisType === AnalysisType.MonographTest
          && x.testCode === analysesDisplay.code
          && x.monographCode === analysesDisplay.monographCode)
          || (x.analysisType === AnalysisType.MonographPackage
            && x.packageCode === analysesDisplay.code
            && x.monographCode === analysesDisplay.monographCode)))).shift();
    const analysesCollection: Analysis[] = [];
    analysesCollection.push(analyses);
    analysesCollection.push(...this.removeAnalysesService.getPreparationTestsToRemove(analyses, this.sample));
    analysesCollection.forEach(async x => {
      // Remove test if already present as part of main tests even if its preparation test
      const isTestEligibleForRemoval = this.sample?.analyses?.filter(c => !c.isMandatory &&
        ((c.eurodatKey && c.eurodatKey !== x.eurodatKey) || (c.testCode && c.testCode !== x.testCode)))
        .map(t => t.testCode).indexOf(x.testCode) !== -1 ?
        true : !this.removeAnalysesService.isTestPreparationTestForOthers(x, this.sample);
      if (isTestEligibleForRemoval) {
        this.removeAnalysesFromCurrentOrder(x);
        await this.removeAnalysesService.removeAnalysis([x], this.currentOrder, this.sampleCode);
      } else {
        // Update is mrt flag to 1 in database
        const patchAnalysisList: Analysis[] = [];
        patchAnalysisList.push(x);
        const invoiceableItemRequest =
          this.addAnalysisService.prepareSampleInvoiceableItemRequest
            ([this.sample], patchAnalysisList, this.currentOrder.quotation.code, true);
        await this.addAnalysisService.updateAnalysisIsMRTFlagToSample(
          this.sampleCode, 'true', invoiceableItemRequest);
      }
    });
    this.sample.analysisDisplay = AnalysesDetailService.setupDisplayAnalysis(this.sample.analyses?.filter(a => !a.isMandatory),
      this.currentOrder.quotedItems?.quotationCommercialItem?.commercialItemSubGroups,this.currentOrder.orderTemplate?.useMultipleDetermination,
      this.currentOrder.standardCommentTemplate?.standardComments, );
    this.setIsAnalysisAdded();
  }

  removeAnalysesFromCurrentOrder(analyses: Analysis) {
    this.currentOrder.samples.forEach(x => {
      if (x === this.sample) {
        if (x.analyses.find(a => a === analyses)) {
          const index = x.analyses.indexOf(analyses);
          if (index > -1) {
            x.analyses.splice(index, 1);
          }
        }
      }
    });
  }

  async removeAllAnalysis(sample: Sample) {
    const currentSample = this.currentOrder.samples.filter(x => x.sampleCode === sample.sampleCode).shift();
    currentSample.product = null;
    this.removeAnalyses.emit();
    await this.removeAnalysesService.removeAllAnalysis(currentSample);
    this.setIsAnalysisAdded();
    await this.removeAnalysesService.resetParametersDisplay(currentSample, this.currentOrder);
  }

  openToolTip(analysis: AnalysisDisplay, event: Event, overlayReference: OverlayPanel) {
    // To stop duplicate calls to API
    if (JSON.stringify(this.previousAnalysisToolTip) !== JSON.stringify(analysis)) {
      this.previousAnalysisToolTip = analysis;
      overlayReference.hide();
      setTimeout(() => {
        this.receiveToolTipEvent(analysis);
        overlayReference.show(event);
      }, 500);
    } else {
      overlayReference.show(event);
    }
  }

  showPreparationTestToolTip(analyses: Analysis) {
    let mainTests = TranslationService.translate('vbeiMandatoryTestsToolTipMessae') + '\n\n';
    this.sample.analyses.forEach(a => {
      if (a.preparationTestCodes) {
        if (a.preparationTestCodes.indexOf(analyses.testCode) !== -1) {
          mainTests = mainTests.concat('[' + a.testCode + ']\t').concat(a.displayName).concat('\n');
        }
      }
    });
    return mainTests;
  }

  receiveToolTipEvent(analysis: AnalysisDisplay) {
    this.toolTipData = null;
    this.monographToolTipData = null;
    if (analysis.analysisType === AnalysisType.SubgroupWithPackage
      || analysis.analysisType === AnalysisType.FreeQLPackage) {
      // get Package data
      this.analysesToolTipService.getPackageToolTipData(this.currentOrder.account.code, analysis.eurodatKey).subscribe(data => {
        this.toolTipData = data;
        this.toolTipData.ciType = CiType.Package;
      });
    } else if (analysis.analysisType === AnalysisType.CustomerPackage) {
      // get Customer Package data
      this.analysesToolTipService.getSubGroupToolTipData(this.currentOrder.account.code,
        analysis.eurodatKey, true, this.currentOrder.orderTemplate.isSampleLevelMatrix).subscribe(data => {
          this.toolTipData = data;
          this.toolTipData.ciType = CiType.Subgroup;
        });
    } else if (analysis.analysisType === AnalysisType.SalesCataloguePackage) {
      this.analysesToolTipService.getPackageCommercialItemToolTipData(analysis.code).then((data) => {
        this.toolTipData = data;
        this.toolTipData = data;
        this.toolTipData.packageCode = data.code;
        this.toolTipData.localisedName = data.name;
        this.toolTipData.ciType = CiType.Package;
      });
    } else if (analysis.analysisType === AnalysisType.MonographTest) {
      this.monographToolTipData = { compendium: analysis.compendiumName, compound: analysis.monographName, ciType: CiType.Test };
    } else if (analysis.analysisType === AnalysisType.MonographPackage) {
      this.analysesToolTipService.getPackageCommercialItemToolTipData(analysis.code).then((data) => {
        this.monographToolTipData = data;
        this.monographToolTipData.compound = analysis.monographName;
        this.monographToolTipData.compendium = analysis.compendiumName;
        this.monographToolTipData.ciType = CiType.Package;
      });
    }
    this.overlayClass = (analysis.analysisType === AnalysisType.MonographTest) ||
      (analysis.analysisType === AnalysisType.MonographPackage)
      ? '' : 'overflow-overlay';
  }

  @HostListener('window:scroll', ['$event'])
  onScrollEvent = () => {
    if (this.overlayReference) {
      this.overlayReference.hide();
      this.toolTipData = null;
      this.previousAnalysisToolTip = null;
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.overlayReference) {
      this.overlayReference.hide();
      this.toolTipData = null;
      this.previousAnalysisToolTip = null;
    }
  }

}
